import { TourRequestModel } from 'src/api/models';

export const isTourRequestActive = (tourRequest: TourRequestModel) => {
  const activeTourRequestStatuses: TourRequestModel['status'][] = [
    'SchedulingInProgress',
    'Submitted',
    'ManualScheduleRequired',
    'OfferSent',
  ];

  return activeTourRequestStatuses.includes(tourRequest.status);
};
